














































































import AccountMixin from './core'
import { of } from 'rxjs'
import {
  skip,
  pluck,
  tap,
  filter,
  debounceTime,
  distinctUntilChanged,
  switchMap,
  map
} from 'rxjs/operators'

export default AccountMixin.extend({
  name: 'PreferencePage',

  subscriptions(){
    const user$ = this.$watchAsObservable('user', { deep: true }).pipe(
      filter(obj=> obj.oldValue !== null),
      skip(1),
      pluck('newValue'),
      map(obj=> ({ theme: obj.theme, lang: obj.lang })),
      debounceTime(700),
      distinctUntilChanged(),
      //@ts-ignore
      switchMap(this.update),
    )
    return {
      user$
    }
  },

  watch: {
    user: {
      deep: true,
      handler(){
        this.setLocalPreference(this.user!.theme!, this.user!.lang!)
      }
    }
  },

  methods: {
    setLocalPreference(theme: string, locale: string) {
      this.$vuetify.theme.dark = theme === 'dark'
      localStorage.setItem('circadian_theme', theme)
      localStorage.setItem('locale_preference', locale)
    }
  }
})
